var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaybtn2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_15652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_13765-2",
    d: "M17.5 1.5c6.47 0 12.3 3.9 14.78 9.88a15.995 15.995 0 01-3.47 17.43A15.993 15.993 0 011.5 17.5c0-2.1.41-4.18 1.21-6.12.81-1.95 1.99-3.71 3.47-5.2 1.49-1.48 3.25-2.66 5.19-3.46A15.89 15.89 0 0117.5 1.5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__media-play-symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_8_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1",
    d: "M14.87 12.25c.05-.03.09-.05.14-.06.05-.01.1-.02.15-.02a.59.59 0 01.28.08l6.75 4.9c.08.05.15.12.2.2.05.09.08.19.08.29 0 .1-.03.19-.08.28-.05.09-.12.16-.2.21l-6.75 4.9c-.09.05-.18.07-.28.07-.1 0-.2-.02-.29-.07a.578.578 0 01-.2-.21.566.566 0 01-.08-.28v-9.8c0-.05.01-.1.02-.15.01-.05.03-.09.06-.14.02-.04.05-.08.09-.11.03-.04.07-.07.11-.09z",
    fill: "#3276e2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybtn2);
export default __webpack_public_path__ + "static/media/playbtn2.0446cea98414138f35082fa40785f3e1.svg";
export { ForwardRef as ReactComponent };